import { apiMethod } from '../../../shared';
import { APINames } from 'src/shared';
import { reportErrorLog, isUndefined, isFunction } from '../../utils';
const apiName = 'offKeyboardHeightChange';

// 移除键盘高度变化全局监听函数。
export function offKeyboardHeightChange(listener: Function) {
  if (isUndefined(listener)) {
    apiMethod.off(APINames.Native.ON_KEYBOARD_HEIGHT_CHANGE);
    return;
  }
  if (!isFunction(listener)) {
    reportErrorLog(apiName, 'callback is not a function');
    return;
  }
  apiMethod.off(APINames.Native.ON_KEYBOARD_HEIGHT_CHANGE, listener);
}
